import { Card, IconButton, Tooltip } from "@/components/atoms";
import { useAppDispatch } from "@/redux/hooks";
import { setAction } from "@/redux/slices/booking/bookingSlice";
import { BookingDetails } from "@/redux/slices/booking/types";
import { DetailField } from "../../../common/DetailField";

interface ExtrasFeesSectionProps {
  booking: BookingDetails;
}

export const ExtrasFeesSection = ({ booking }: ExtrasFeesSectionProps) => {
  const dispatch = useAppDispatch();
  const { extras, fees } = booking;

  const handleExtrasFeesClick = () => {
    dispatch(setAction("extras-and-fees"));
  };

  const extrasCount = extras?.reduce((total, extra) => total + (extra.quantity || 1), 0) || 0;
  const feesCount = fees?.reduce((total, fee) => total + (fee.quantity || 1), 0) || 0;

  const getSummaryText = () => {
    if (extrasCount === 0 && feesCount === 0) {
      return "No Extras or Fees";
    }

    const parts = [];
    if (extrasCount > 0) {
      parts.push(`${extrasCount} Extra${extrasCount !== 1 ? "s" : ""}`);
    }
    if (feesCount > 0) {
      parts.push(`${feesCount} Fee${feesCount !== 1 ? "s" : ""}`);
    }

    return parts.join(" and ");
  };

  return (
    <Card className="space-y-3 p-2.5">
      <DetailField
        leading={
          <div className="flex h-6 w-6 items-center justify-center">
            <div className={`h-[10px] w-[10px] rounded-full border-2 border-neutral-dark-gray`} />
          </div>
        }
        label="Extras and Fees"
        value={getSummaryText()}
        right={
          extrasCount > 0 || feesCount > 0 ? (
            <Tooltip content="View Extras and Fees" placement="top">
              <IconButton
                iconName="ArrowRight"
                iconSize="md"
                size="xs"
                variant="primary"
                className="h-8 w-8"
                onClick={handleExtrasFeesClick}
              />
            </Tooltip>
          ) : undefined
        }
      />
    </Card>
  );
};
